var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKartiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.66,11.37c-0.22,0.14-0.21,0.13-0.35,0.22c1.34-2.11,2.9-4.77,2.9-6.25c0-2.95-2.39-5.33-5.33-5.33 C9.93,0,7.54,2.39,7.54,5.33c0,0.71,0.26,1.5,0.74,2.53L2.07,12v12l6.62-4.14l6.62,3.72l6.62-2.48V7.45 C21.93,7.45,17.02,10.52,15.66,11.37z M12.81,2.56c1.34,0,2.43,1.09,2.43,2.42s-1.09,2.42-2.43,2.42s-2.43-1.09-2.43-2.42 S11.47,2.56,12.81,2.56z M15.31,21.93l-6.62-3.72V8.28l4.18,6.53l1.91-2.67l0.01-0.01l0.52,0.29V21.93z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKartiIcon);
export default __webpack_public_path__ + "static/media/karti_icon.1f63d07d.svg";
export { ForwardRef as ReactComponent };